import { useTranslate } from "@similarweb/i18n-provider";
import { ChevronDown } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

export const WaterfallConnector = () => {
    const { translate } = useTranslate();

    return (
        <Flex
            flexDirection="column"
            alignItems="center"
            margin="2px 0"
        >
            <Text
                fontVariant="queryBar1"
                color={colorsPalettes.carbon[200]}
                textTransform="uppercase"
            >
                {translate("si.pages.contacts_waterfall.fallback")}
            </Text>
            <Box
                width="1px"
                height="10px"
                margin="2px 0 -6px"
                background={colorsPalettes.carbon[100]}
            />
            <ChevronDown
                size="xs"
                color={colorsPalettes.carbon[100]}
            />
        </Flex>
    );
};
